import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=2322cbe8&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
import style0 from "./Search.vue?vue&type=style&index=0&id=2322cbe8&lang=scss"
import style1 from "./Search.vue?vue&type=style&index=1&id=2322cbe8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322cbe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2322cbe8')) {
      api.createRecord('2322cbe8', component.options)
    } else {
      api.reload('2322cbe8', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=2322cbe8&scoped=true", function () {
      api.rerender('2322cbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/apps/search/components/Search.vue"
export default component.exports